<app-navbar *ngIf="isClientRoute()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</app-navbar>

<app-main-navbar *ngIf="!isClientRoute() || isComparisonRoute() || isMafRoute()">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</app-main-navbar>

<ng-template #content>
    <div class="content-wrapper" id="main-content">
      <div [ngClass]="{ 'content-inner': isClientRoute(), 'content-main-inner': !isClientRoute() || isComparisonRoute() || isMafRoute()}">
        <router-outlet></router-outlet>
      </div>
    </div>
</ng-template>